const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ2: {
				name: ['出勤作業', 'Attendance operation', '出勤作业'],
				children: {
					ZZ_GOODLIVER_AM10020: {
						name: ['排班工時結算啟動', 'Shift hours start reckon', '排班工时结算启动'],
						url: '/zz_goodliver_am10020',
						hint: [],
					},
					ZZ_GOODLIVER_AM10030: {
						name: ['排班工時結算鎖檔', 'Shift hours lock reckon', '排班工时结算锁档'],
						url: '/zz_goodliver_am10030',
						hint: [],
					},
				},
			},
			ZZ3: {
				name: ['薪資作業', '薪資作業', '薪資作業'],
				children: {
					ZZ_GOODLIVER_PB10960: {
						name: ['人員薪資袋合併設定', '人員薪資袋合併設定', '人員薪資袋合併設定'],
						url: '/zz_goodliver_pb10960',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};